import { render, staticRenderFns } from "./FallBattery.vue?vue&type=template&id=5427995c"
import script from "./FallBattery.vue?vue&type=script&lang=js"
export * from "./FallBattery.vue?vue&type=script&lang=js"
import style0 from "./FallBattery.vue?vue&type=style&index=0&id=5427995c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports